import type { SVGProps } from 'react';

export function CursorIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18 14L42 32L30 35L25 47L18 14Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="none"
      />
      <path d="M14 8L18 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M8 22L14 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M10 12L15 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
